// extracted by mini-css-extract-plugin
module.exports = {"favorites-sounds":"favorite-sounds_favorites-sounds__LfQEA"};